module.exports = __webpack_public_path__ + "img/GBM1_CD8T.c7eae1de.png";